import React, { useCallback, useContext } from 'react';
import { Loader } from 'ncoded-component-library';
import BuySide from '../BuySide';
import SellSide from '../SellSide';
import MembersContext from 'router/subrouters/DataRoom/providers/Members/Members.context';
import useCallbackRef from 'hooks/useCallbackRef';
import { CollapsibleRef } from 'ncoded-component-library/build/components/molecules/Collapsible/Collapsible.component';

type MembersDesktopProps = {
  onlyNew?: boolean;
};

const MembersDesktop: React.FC<MembersDesktopProps> = ({ onlyNew = false }) => {
  const { isLoading, buySideNewMembers, sellSideNewMembers } =
    useContext(MembersContext);

  const [sellSide, sellSideRef] = useCallbackRef<CollapsibleRef>(null);
  const [buySide, buySideRef] = useCallbackRef<CollapsibleRef>(null);

  const onBuySideClick = useCallback(() => {
    if (!buySide?.open) {
      sellSide.setOpen(false);
    }
  }, [buySide?.open, sellSide]);

  const onSellSideClick = useCallback(() => {
    if (!sellSide?.open) {
      buySide.setOpen(false);
    }
  }, [buySide, sellSide?.open]);

  return (
    <div className="members__container">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {onlyNew && !buySideNewMembers.length ? null : (
            <BuySide
              ref={buySideRef}
              className="collapsible-container-groups"
              onlyNew={onlyNew}
              onClick={onBuySideClick}
            />
          )}

          {onlyNew && !sellSideNewMembers.length ? null : (
            <SellSide
              ref={sellSideRef}
              onlyNew={onlyNew}
              onClick={onSellSideClick}
            />
          )}
        </>
      )}
    </div>
  );
};

export default MembersDesktop;
